<template>
  <div class="container" @click="goToHome">
    <div v-if="errorMessage" class="content">
      <p class="no-content-message">{{ errorMessage }}</p>
    </div>
    <div v-else-if="currentFile" class="media-container">
      <video v-if="isVideo" ref="screensaverVideo" class="fullscreen-video" autoplay muted @ended="nextFile">
        <source :src="currentFile" type="video/mp4" />
        Votre navigateur ne supporte pas les vidéos HTML5.
      </video>
      <img v-else class="fullscreen-image" :src="currentFile" @load="startImageTimer" />
    </div>
    <div v-else class="content">
      <p class="no-content-message">Il n'y a pas de contenu à afficher dans {{ contentUrl }}</p>
    </div>
    <div class="footer">
      Made by Des Choses Pareilles - Version {{ $store.state.packageVersion }} {{ queryParams }}
    </div>
  </div>
</template>

<script>

import domains from '@/assets/data/domains.js';

export default {
  data() {
    return {
      files: [],
      currentIndex: 0,
      contentUrl: '',
      errorMessage: '',
    };
  },
  computed: {
    currentFile() {
      return this.contentUrl + (this.files.length > 0 ? this.files[this.currentIndex] : null);
    },
    isVideo() {
      return this.currentFile && this.currentFile.endsWith(".mp4");
    }
  },
  mounted() {
    console.log('Component mounted');

    const unitName = this.$route?.query?.unitName;
    console.log('unitName from URL =', unitName);

    if (!unitName) {
      this.errorMessage = `Paramètre "unitName" manquant dans l'URL`;
      console.warn(this.errorMessage);
      return;
    }


    console.log('unitname in url');


    if (typeof unitName !== 'string' || !unitName.trim() || !domains[unitName]) {
      this.errorMessage = `No domain for unitName = ${unitName || '[none]'}`;
      console.warn(this.errorMessage);
      return;
    }

    const domain = domains[unitName];
    this.contentUrl = `https://netplus.choses.ch/content/${domain}/`;
    console.log('Resolved contentUrl =', this.contentUrl);

    this.fetchFiles();
  }
  ,
  methods: {
    async fetchFiles() {
      try {
        const response = await fetch(this.contentUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const links = Array.from(doc.querySelectorAll("a"))
          .map((a) => a.innerText)
          .filter((href) => href.match(/\.(mp4|jpg|png|jpeg)$/i))
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

        this.files = links;

        if (this.files.length === 0) {
          console.warn("Aucun fichier trouvé.");
        } else {
          console.log(this.files);
          this.startSlideshow();
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des fichiers :", error);
      }
    },
    startSlideshow() {
      if (this.files.length > 0) {
        this.currentIndex = 0;
      }
    },
    nextFile() {

      if (this.files.length <= 1) {
        this.restartCurrentVideo();
        return;
      }

      this.currentIndex = (this.currentIndex + 1) % this.files.length;
    },

    restartCurrentVideo() {
      this.$nextTick(() => {
        const video = this.$refs.screensaverVideo;

        if (!video) return;

        video.currentTime = 0;
        video.load();
        video.play();
      });
    },

    startImageTimer() {
      setTimeout(this.nextFile, 5000);
    },
    goToHome() {
      this.$router.push({ name: "home" });
    }
  },
  watch: {
    currentIndex() {
      this.$nextTick(() => {
        if (this.isVideo && this.$refs.screensaverVideo) {
          this.$refs.screensaverVideo.load();
          this.$refs.screensaverVideo.play();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: $secondary-color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.media-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-video,
.fullscreen-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-content-message {
  font-size: 1.5rem;
  color: black;
  text-align: center;
  padding: 20px;
}
</style>
